/**
 *
 *  A simple utility function to create a delay in milliseconds.
 */
export function wait(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
